import { WorldDetail } from '../../api/types/shared';
import { fallbackImage } from '../../assets/images';
import scenarioStyles from '../scenario/ViewScenario.module.css';
import styles from './ViewWorld.module.css';
import { useState } from 'react';
import CharacterDetailsModal from '../scenario/CharacterDetailsModal';
import { ScenarioCharacter } from '../../api/types/scenario';

interface ViewWorldProps {
  world: WorldDetail;
}

function ViewWorld({ world }: ViewWorldProps): JSX.Element {
  const imageUrl = world.icon || fallbackImage;
  // Add state for the character details modal
  const [selectedCharacter, setSelectedCharacter] = useState<ScenarioCharacter | null>(null);
  const [showCharacterModal, setShowCharacterModal] = useState(false);

  // Handler for character card click
  const handleCharacterClick = (character: ScenarioCharacter) => {
    setSelectedCharacter(character);
    setShowCharacterModal(true);
  };

  return (
    <div className={scenarioStyles.verticalContainer}>
      <div className={scenarioStyles.scenarioImageSection}>
        <div className={scenarioStyles.imageContainer}>
          <div className={scenarioStyles.imageWrapper}>
            <img 
              src={imageUrl} 
              alt={world.display_name} 
              className={scenarioStyles.scenarioFullImage}
            />
          </div>
        </div>
      </div>
      
      <div className={scenarioStyles.scenarioDetailsSection}>
        <div className={scenarioStyles.scenarioHeader}>
          <div className={scenarioStyles.titleContainer}>
            <div className={scenarioStyles.titleRow}>
              <h1 className={styles.worldTitle}>
                {world.display_name}
              </h1>
            </div>
          </div>
          
          {/* Characters Section */}
          <div className={scenarioStyles.charactersSection}>
            <div className={scenarioStyles.sectionHeader}>
              <h3 className={scenarioStyles.sectionTitle}>CHARACTERS</h3>
            </div>
            
            {world.characters && world.characters.length > 0 ? (
              <div className={scenarioStyles.charactersGrid}>
                {world.characters.map((character) => (
                  <div 
                    key={character.id} 
                    className={scenarioStyles.characterCardWrapper}
                    onClick={() => handleCharacterClick(character)}
                  >
                    <div className={styles.card}>
                      <div className={styles.avatarContainer}>
                        <img 
                          src={character.icon} 
                          alt={character.display_name} 
                          className={styles.avatar}
                        />
                      </div>
                      <div className={styles.contentContainer}>
                        <h3 className={styles.name}>{character.display_name}</h3>
                        <p className={styles.tagline}>{character.tagline}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.emptyCharactersState}>
                <p>This world doesn't have any characters yet.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Character Details Modal */}
      <CharacterDetailsModal
        isOpen={showCharacterModal}
        onClose={() => setShowCharacterModal(false)}
        character={selectedCharacter}
      />
    </div>
  );
}

export default ViewWorld;
